import React from "react";
import { STATUS_LABELS } from "@/lib/api";

const COLOR_MAP = {
  lead: "border-[#A3A8A4]/40 text-[#A3A8A4] bg-[#A3A8A4]/5",
  consult: "border-[#D2A853]/50 text-[#D2A853] bg-[#D2A853]/10",
  deposit_pending: "border-[#E2BC6A]/60 text-[#E2BC6A] bg-[#E2BC6A]/10",
  deposit_paid: "border-[#4CAF50]/50 text-[#4CAF50] bg-[#4CAF50]/10",
  booked: "border-[#4CAF50]/60 text-[#4CAF50] bg-[#4CAF50]/15",
  completed: "border-[#A3A8A4]/40 text-[#A3A8A4] bg-[#A3A8A4]/5",
};

export default function StatusBadge({ status }) {
  const label = STATUS_LABELS[status] || status;
  const cls = COLOR_MAP[status] || COLOR_MAP.lead;
  return (
    <span
      className={`inline-flex items-center px-3 py-1 border ${cls} overline text-[10px]`}
      data-testid={`status-badge-${status}`}
    >
      {label}
    </span>
  );
}
